
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

export const SUPABASE_URL = "https://vudlhhwvvamuhdfnixsn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ1ZGxoaHd2dmFtdWhkZm5peHNuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE5OTIwOTEsImV4cCI6MjA1NzU2ODA5MX0.xja_b-r9pIaPuQXKaVlN9K8xsATvPiQbMkQX6LDGnX0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Configure with retry logic and longer timeouts
export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
    },
    global: {
      fetch: (url, options) => {
        // Set longer timeout for all requests
        const timeoutController = new AbortController();
        const timeoutId = setTimeout(() => timeoutController.abort(), 30000); // 30 second timeout
        
        // Combine the abort signal with any existing one
        const originalSignal = options?.signal;
        const abortCallback = () => timeoutController.abort();
        
        if (originalSignal) {
          originalSignal.addEventListener('abort', abortCallback);
        }
        
        const fetchOptions = {
          ...options,
          signal: timeoutController.signal,
        };
        
        return fetch(url, fetchOptions)
          .then(response => {
            clearTimeout(timeoutId);
            if (originalSignal) {
              originalSignal.removeEventListener('abort', abortCallback);
            }
            return response;
          })
          .catch(error => {
            clearTimeout(timeoutId);
            if (originalSignal) {
              originalSignal.removeEventListener('abort', abortCallback);
            }
            throw error;
          });
      },
    },
  }
);
